import { Button, Dropdown, Heading, Text } from "components/common";
import classes from "./Navbar.module.css";
import { TbSettings } from "react-icons/tb";
import { PiFan } from "react-icons/pi";

import clsx from "clsx";
import { useState } from "react";

import { PiSidebar } from "react-icons/pi";
import { useScroll } from "hooks/useScroll";
import { useParams } from "react-router-dom";
import Models from "../Models/Models";
import { liamaLogo, smartAdvisor } from "images";
import { toast } from "react-toastify";
import { db } from "db";
import { nuke } from "App";
// const allModles = [
//   {
//     version: "L7",
//     name: "Llama 3.2 3B",
//     logo: liamaLogo,
//     id: "dolphin-2.9.2-qwen2-72b1",
//     is_premium: false,
//     is_serving: true,
//     model_type: "Chat",
//     tags: ["Beta"],
//     writing: "100k",
//   }
// ];
const Navbar = ({
  sidebar,
  rightSidebar,
  setSidebar,
  setRightSidebar,
  setSelectedModel,
  selectedModel,
  models,
  aiCharacters,
  showSelectAiDropdown,
  setShowSelectAiDropdown,
  userData,
}) => {
  let { aiCharacter } = useParams();
  const isScrolled = useScroll(50);
  // select Ai model dropdown
  // const [selectedAiModel, setSelectedAiModel] = useState("GPT-4o");
  const [activeModelType, setActiveModelType] = useState("Chat");
  const modelTypes = ["Chat", "Image", "Voice"];
  return (
    <div
      className={clsx(
        classes.wrapper,
        isScrolled && classes.wrapperBg,
        !sidebar && classes.noLeftSidebarWrapper,
        !rightSidebar && classes.noRightSidebarWrapper
      )}
    >
      <nav className={clsx(classes.nav, "container2")}>
        <button
          className={classes.sidebarButton}
          onClick={() => setSidebar((prev) => !prev)}
        >
          <PiSidebar />
        </button>

        {aiCharacter && (
          <img
            src={
              aiCharacter
                ? aiCharacters?.find((a) => a.id == aiCharacter)?.img ||
                  "https://cdn-icons-png.flaticon.com/128/9732/9732800.png"
                : ""
            }
            alt="#"
            className={classes.characterIcon}
          />
        )}
        {/* {!aiCharacter && (
          <img
            src={selectedModel?.icon}
            alt="#"
            className={classes.characterIcon}
          />
        )} */}
        {!aiCharacter && (
          <Models
            className={classes.dropdown}
            isActive={showSelectAiDropdown}
            setIsActive={setShowSelectAiDropdown}
            selectedModel={selectedModel}
            activeModelType={activeModelType}
            setActiveModelType={setActiveModelType}
            modelTypes={["Chat", "Image", "Voice"]}
            onSelect={(model) => setSelectedModel(model)}
            models={models}
            userData={userData}
          />
        )}
        <div className={classes.buttonContainer}>
          {/* <Button
            onClick={() => {
              nuke();
            }}
            primitive800
            sm
            className={clsx(classes.settingButton, classes.button)}
          >
            <PiFan />
          </Button> */}
          {/* <Button
            primitive800
            sm
            className={classes.settingButton}
            onClick={() => setRightSidebar((prev) => !prev)}
          >
            <TbSettings />
          </Button> */}
        </div>
      </nav>
    </div>
  );
};
export default Navbar;
